<template>
  <div id="units_recap" >
  <!--<b-card class="table-responsive text-sm pt-2 border-1">-->
    <div style="max-width:300px;">
      <b-form-group>
        <b-input-group size="sm">
          <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <div >
    <b-table
      small 
      caption-top 
      id="table-unit-list"
      primary-key="carrier_code+'-'+customer_id"
      class="table-grid"
      striped
      hover
      outlined
      show-empty
      table-variant="light"
      :items="get_recap_data"
      :fields="get_fields(search_type)"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      @filtered="onFiltered"
    >
    <!--
      <template v-slot:cell(customer_name)="data">
        <span >{{ data.value.substring(0,30) + (data.value.length > 30 ? " ..." : "") }}</span>
      </template>
    -->
      <template v-slot:cell(number_of_units)="data">
        <span>{{ data.value | numFormat(integer_format) }}</span>
      </template>
      <template v-slot:cell(unpaid_demurrage)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(unpaid_detention)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(unpaid_chassis)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(unpaid_total)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(j0_10)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(j11_30)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(j31_90)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(j91_180)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(j181_365)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(j366_0)="data">
        <span>{{ data.value | numFormat(currency_format) }}</span>
      </template>
      <template v-slot:cell(show_details)="row">
        <span
          class="btn btn-primary btn-sm"
          @click="show_details(row.item.carrier_code,row.item.customer_id)"
        >
          <i class="fa fa-eye" aria-hidden="true"></i>
        </span>
      </template>
      <template slot="bottom-row" v-if="getTotalRows>1 ">
        <td v-show="showCarrierColumn && showConsigneeColumn"></td>
        <td >Total :</td>
        <td class="text-right font-weight-bold">{{ total_number_of_units | numFormat(integer_format) }}</td>
        <td class="text-right">{{ total_unpaid_demurrage | numFormat(currency_format) }}</td>
        <td class="text-right" v-show="showDetentionCharge">{{ total_unpaid_detention | numFormat(currency_format) }}</td>
        <td class="text-right" v-show="showChassisCharge">{{ total_unpaid_chassis | numFormat(currency_format) }}</td>
        <td class="text-right font-weight-bold" v-show="showDetentionCharge">{{ total_unpaid_amount | numFormat(currency_format) }}</td>
        <td class="text-right">{{ total_j0_10 | numFormat(currency_format) }}</td>
        <td class="text-right">{{ total_j11_30 | numFormat(currency_format) }}</td>
        <td class="text-right">{{ total_j31_90 | numFormat(currency_format) }}</td>
        <td class="text-right">{{ total_j91_180 | numFormat(currency_format) }}</td>
        <td class="text-right">{{ total_j181_365 | numFormat(currency_format) }}</td>
        <td class="text-right">{{ total_j366_0 | numFormat(currency_format) }}</td>
        <td class="text-right"><span class="btn btn-primary btn-sm" @click="show_details('');">All</span></td>
      </template>
    </b-table>
    </div>
    <b-pagination
      v-show="getTotalRows > perPage"
      v-model="currentPage"
      :total-rows="getTotalRows"
      :per-page="perPage"
      aria-controls="my-table"
      align="fill"
      size="sm"
    />
  <!--</b-card>-->
  </div>
</template>

<script>
export default {
  name: "units_summary",
  props: {
    search_type: String,
    show_age: Boolean,
    show_details: Function,
    refresh_data: Function,
    recap_data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      integer_format: "0,0",
      currency_format: "$ 0,0.00",
      currentPage: 1,
      totalRows: 0,
      numberUnitPerPage: 0,
      data_totals: {},
      //search_type: "???",

      unit_fields: [
        { key: "customer_name", label: "Consignee", sortable: true, class: "font-weight-bold", },
        { key: "carrier_code", label: "Carrier", sortable: true, class: "font-weight-bold",},
        { key: "number_of_units", label: "Units", sortable: true, class: "text-right font-weight-bold", },
        { key: "unpaid_demurrage", label: "Demurrage", sortable: true, class: "text-right", },
        { key: "unpaid_detention", label: "Detention", sortable: true, class: "text-right", },
        { key: "unpaid_chassis", label: "Chassis", sortable: true, class: "text-right", },
        { key: "unpaid_total", label: "Total", sortable: true, class: "text-right font-weight-bold",} ,
        { key: "j0_10", label: "1 - 10 days", sortable: true, class: "text-right", },
        { key: "j11_30", label: "11 - 30 days", sortable: true, class: "text-right", },
        { key: "j31_90", label: "31 - 90 days", sortable: true, class: "text-right", },
        { key: "j91_180", label: "91 - 180 days", sortable: true, class: "text-right", },
        { key: "j181_365", label: "181 - 365 days", sortable: true, class: "text-right", },
        { key: "j366_0", label: "366 days +", sortable: true, class: "text-right", },
        { key: "show_details", label: "", class: "text-right",},
      ],
      filter: null,
      filterOn: ["carrier_code", "customer_name"],
      itemsFiltered: [],
    };
  },
  computed: {
    showCarrierColumn(){
      return this.$store.state.current_profile.type != 4;
    },
    showConsigneeColumn(){
      return this.$store.state.current_profile.type != 6;
    },
    showDemurrageCharge(){
      //if (this.search_type == "FULL_AT_CONSIGNEE" || this.search_type == "FULL_AT_TERMINAL") return false;
      return true;
    },
    showDetentionCharge(){
      if (this.search_type == "FULL_AT_TERMINAL") return false;
      return true;
    },
    showChassisCharge(){
      if (this.search_type == "FULL_AT_TERMINAL") return false;
      if (this.$store.state.current_profile.type == 4) return false;
      return true;
    },
    perPage() {
      return this.numberUnitPerPage <= 0
        ? this.getTotalRows
        : this.numberUnitPerPage;
    },
    getTotalRows() {
      try {
        return this.filter ? this.totalRows : this.get_data.length;
      } catch {
        return 0;
      }
    },
    get_data: function () {
      if (this.search_type == "FULL_AT_TERMINAL") return this.$store.getters.units_at_terminal_recap;
      if (this.search_type == "FULL_AT_CONSIGNEE") return this.$store.getters.units_at_consignee_recap;
      if (this.search_type == "UNPAID_EMPTY_UNITS") return this.$store.getters.units_with_outstanding_recap;
      return this.recap_data;
    },
    get_recap_data: function() {
      return this.get_data.map(d => {
        d.unpaid_total = (d.unpaid_demurrage || 0) + (d.unpaid_detention || 0) + (d.unpaid_chassis || 0);
        if(d.customer_name) {
          d.customer_name = d.customer_name.substring(0,30) + (d.customer_name.length > 30 ? " ..." : "")
        }
        return d;
      });
    },
    total_number_of_units() {
      try {
        return this.filter
          ? this.data_totals.total_number_of_units
          : this.get_data.reduce((sum, cv) => sum + cv.number_of_units, 0);
      } catch {
        return 0;
      }
    },
    total_unpaid_demurrage() {
      try {
        return this.filter
          ? this.data_totals.total_unpaid_demurrage
          : this.get_data.reduce((sum, cv) => sum + cv.unpaid_demurrage, 0);
      } catch {
        return 0;
      }
    },
    total_unpaid_detention() {
      try {
        return this.filter
          ? this.data_totals.total_unpaid_detention
          : this.get_data.reduce((sum, cv) => sum + cv.unpaid_detention, 0);
      } catch {
        return 0;
      }
    },
    total_unpaid_chassis() {
      try {
        return this.filter
          ? this.data_totals.total_unpaid_chassis
          : this.get_data.reduce((sum, cv) => sum + cv.unpaid_chassis, 0);
      } catch {
        return 0;
      }
    },
    total_unpaid_amount() {
      return (this.total_unpaid_demurrage || 0) + (this.total_unpaid_detention || 0) + (this.total_unpaid_chassis || 0);
    },
    total_j0_10() {
      try {
        return this.filter
          ? this.data_totals.j0_10
          : this.get_data.reduce((sum, cv) => sum + (cv.hasOwnProperty('j0_10') ? cv.j0_10 : 0), 0);
      } catch {
        return 0;
      }
    },
    total_j11_30() {
      try {
        return this.filter
          ? this.data_totals.j11_30
          : this.get_data.reduce((sum, cv) => sum + (cv.hasOwnProperty('j11_30') ? cv.j11_30 : 0), 0);
      } catch {
        return 0;
      }
    },
    total_j31_90() {
      try {
        return this.filter
          ?this.data_totals.j31_90
          : this.get_data.reduce((sum, cv) => sum + (cv.hasOwnProperty('j31_90') ? cv.j31_90 : 0), 0);
      } catch {
        return 0;
      }
    },
    total_j91_180() {
      try {
        return this.filter
          ? this.data_totals.j91_180
          : this.get_data.reduce((sum, cv) => sum + (cv.hasOwnProperty('j91_180') ? cv.j91_180 : 0), 0);
      } catch {
        return 0;
      }
    },
    total_j181_365() {
      try {
        return this.filter
          ? this.data_totals.j181_365
          : this.get_data.reduce((sum, cv) => sum + (cv.hasOwnProperty('j181_365') ? cv.j181_365 : 0), 0);
      } catch {
        return 0;
      }
    },
    total_j366_0() {
      try {
        return this.filter
          ? this.data_totals.j366_0
          : this.get_data.reduce((sum, cv) => sum + (cv.hasOwnProperty('j366_0') ? cv.j366_0 : 0), 0);
      } catch {
        return 0;
      }
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.data_totals.total_number_of_units = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('number_of_units') ? cv.number_of_units : 0), 0)
      this.data_totals.total_unpaid_demurrage = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('unpaid_demurrage') ? cv.unpaid_demurrage : 0), 0)
      this.data_totals.total_unpaid_detention = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('unpaid_detention') ? cv.unpaid_detention : 0), 0)
      this.data_totals.total_unpaid_chassis = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('unpaid_chassis') ? cv.unpaid_chassis : 0), 0)
      //this.data_totals.total_unpaid_amount = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j0_30') ? cv.j0_30 : 0), 0)
      this.data_totals.j0_10 = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j0_10') ? cv.j0_10 : 0), 0)
      this.data_totals.j11_30 = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j11_30') ? cv.j11_30 : 0), 0)
      this.data_totals.j31_90 = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j31_90') ? cv.j31_90 : 0), 0)
      this.data_totals.j91_180 = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j91_180') ? cv.j91_180 : 0), 0)
      this.data_totals.j181_365 = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j181_365') ? cv.j181_365 : 0), 0)
      this.data_totals.j366_0 = filteredItems.reduce((sum, cv) => sum + (cv.hasOwnProperty('j366_0') ? cv.j366_0 : 0), 0)
    },
    get_fields(s) {
      let cp = this.$store.state.current_profile;
      return this.unit_fields.filter(function (u) {
        let show = true;
        if (s == "FULL_AT_TERMINAL") {
          show = (u.key != "unpaid_detention" && u.key != "unpaid_chassis" && u.key != "unpaid_total");
        } else if (s == "FULL_AT_CONSIGNEE") {
          show = (u.key != "gi_date");
        } else {
          show = (u.key != "last_free_day");
        }
        if (!show) return false;
        if (u.key == "carrier_code" && cp.type == 4) return false
        if (u.key == "unpaid_chassis" && cp.type == 4) return false
        if (u.key == "customer_name" && cp.type == 6) return false
        return show;
      });


    },
  }
};
</script>